import { useOffreService } from '@europrocurement/l2d-domain';
import {
    TblRelPrescripteurArticleJsonld,
    TblRelPrescripteurArticleJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFullCatalogueReadGrilleTarifaireSurchargePrescripteur,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';

export type OffrePrescripteurRelArticle =
    TblRelPrescripteurArticleJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFullCatalogueReadGrilleTarifaireSurchargePrescripteur &
        Record<string, unknown>;

const useOffreForm = () => {
    const { tblPrescripteurArticleApi } = useOffreService();

    const createSurchargeArticle = (
        article: TblRelPrescripteurArticleJsonld,
    ): Promise<OffrePrescripteurRelArticle> =>
        new Promise((resolve, reject) => {
            const requestParameters: TblRelPrescripteurArticleJsonld = { ...article };

            const createPrescripteurRelArticleTimeout = setTimeout(() => {
                tblPrescripteurArticleApi
                    .apiArticlePrescripteurPost({
                        tblRelPrescripteurArticleJsonld: requestParameters,
                    })
                    .then((res) => resolve(res.data as OffrePrescripteurRelArticle))
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
            console.warn(createPrescripteurRelArticleTimeout);
        });

    const updateSurchargeArticle = (
        id: string,
        article: TblRelPrescripteurArticleJsonld,
    ): Promise<OffrePrescripteurRelArticle> =>
        new Promise((resolve, reject) => {
            const requestParameters: TblRelPrescripteurArticleJsonld = { ...article };

            const updatePrescripteurRelArticleTimeout = setTimeout(() => {
                tblPrescripteurArticleApi
                    .apiArticlePrescripteurIdPut({
                        id,
                        tblRelPrescripteurArticleJsonld: requestParameters,
                    })
                    .then((res) => resolve(res.data as OffrePrescripteurRelArticle))
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
            console.warn(updatePrescripteurRelArticleTimeout);
        });

    const deleteSurchargeArticle = (id: string): Promise<void> =>
        new Promise((resolve, reject) => {
            const deletePrescripteurRelArticleTimeout = setTimeout(() => {
                tblPrescripteurArticleApi
                    .apiArticlePrescripteurIdDelete({
                        id,
                    })
                    .then(() => resolve())
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
            console.warn(deletePrescripteurRelArticleTimeout);
        });
    return { createSurchargeArticle, updateSurchargeArticle, deleteSurchargeArticle };
};

export default useOffreForm;
